import { CONTRACTS_REVIEW, LOGIN } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import { get } from 'lodash';

const initialState = {
    fetched: false,
    fetching: false,
    commenting: false,
    submitMessage: 'Submitting contract review...',
    signed: false,
    submitting: false,
    signName: '',
    signFunction: '',
    signEmail: '',
    currentComment: '',
    comments: {},
    contract: {}
};

function review(state = initialState, action) {
    switch (action.type) {
        case CONTRACTS_REVIEW.FETCH_START:
            return { ...state, fetching: true };
        case CONTRACTS_REVIEW.FETCH_OK:
            return {
                ...state,
                comments: get(action.contract, 'version.comments', {}),
                fetching: false,
                fetched: true,
                contract: action.contract
            };
        case CONTRACTS_REVIEW.OPEN:
            return { ...state, commenting: action.target, currentComment: state.comments[action.target.id] || '' };
        case CONTRACTS_REVIEW.CLOSE:
            return { ...state, commenting: false, currentComment: '' };
        case CONTRACTS_REVIEW.INPUT:
            return { ...state, [action.field]: action.value };
        case CONTRACTS_REVIEW.CHANGE:
            return { ...state, commenting: false, comments: { ...state.comments, [action.elementId]: action.value } };
        case CONTRACTS_REVIEW.SWITCH:
            return { ...state, contract: { ...state.contract, version: action.version } };
        case CONTRACTS_REVIEW.TOGGLE:
            return { ...state, signed: !state.signed };
        case CONTRACTS_REVIEW.SUBMIT:
            return { ...state, submitting: true, submitMessage: action.submitMessage || initialState.submitMessage };
        case CONTRACTS_REVIEW.SUBMIT_DONE:
            return { ...state, submitting: false, submitMessage: initialState.submitMessage };
        case LOGIN.CANCEL:
            return initialState;
        case LOCATION_CHANGE:
            if (get(action, 'payload.pathname') === `/contracts/${state.contract.id}`) {
                return state;
            } else {
                return initialState;
            }
        default:
            return state;
    }
}

export default review;
